import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50 px-4">
      <div className="w-full max-w-sm">
        <Link to="/" className="mb-8 flex justify-center">
          <img src="/kk-logo.png" alt="KK Beauty & Fashion" className="h-12 w-auto max-w-full" />
        </Link>
        <div className="border border-zinc-200 bg-white p-8">
          <div className="mb-6 flex items-center gap-2">
            <Lock size={16} className="text-kkaccent" />
            <h1 className="font-display text-lg">Admin Login</h1>
          </div>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label className="text-xs uppercase tracking-wider text-zinc-500">Email</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 rounded-none border-zinc-300"
                required
                data-testid="login-email"
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-zinc-500">Password</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1.5 rounded-none border-zinc-300"
                required
                data-testid="login-password"
              />
            </div>
            {error && <p className="text-sm text-kksale" data-testid="login-error">{error}</p>}
            <Button
              type="submit"
              disabled={loading}
              className="h-11 w-full rounded-none bg-zinc-900 text-xs uppercase tracking-widest hover:bg-zinc-800"
              data-testid="login-submit"
            >
              {loading ? "Signing in…" : "Sign In"}
            </Button>
          </form>
          <Link to="/admin/forgot-password" className="mt-4 block text-center text-xs text-zinc-500 hover:text-zinc-900" data-testid="forgot-link">
            Forgot password?
          </Link>
        </div>
      </div>
    </div>
  );
}
